import React from 'react';
import moment from 'moment';
import {useMutation, useQuery} from '@apollo/client';
import {updateCreate} from '../../utils/mutation';
import TransactionList from '../Transaction/List';
import {MUTATION_TRANSACTION_TARIFF, QUERY_TRANSACTION_LIST} from '../Transaction/graphql';
import {QUERY_USER} from './graphql';
import {TARIFFS} from './constants';
import {isActive} from './utils';

const ClientPayments = () => {
  const {user} = useQuery(QUERY_USER).data;

  const [activate] = useMutation(MUTATION_TRANSACTION_TARIFF, {
    update: (cache, response) => updateCreate(cache, response, {query: QUERY_TRANSACTION_LIST}),
  });

  return (
    <div className="row py-4 gy-4 gx-lg-5">
      <div className="col-lg-6">
        <div className="fs-5">Платежи</div>
        <div className="fw-bold">
          Баланс: {user.client.balance} тг. (ID: {('000000' + user.client.id).slice(-6)})
        </div>
        <TransactionList />
      </div>
      <div className="col-lg-6">
        <div className="fs-5">Тарифы</div>
        <div className="fw-bold">
          Активность: до{' '}
          {user.client.activeTill ? (
            <span>
              {moment(user.client.activeTill).format('DD MMM YYYY, HH:mm')}{' '}
              {!isActive(user) && <span className="text-warning">(просрочен)</span>}
            </span>
          ) : (
            <span className="text-warning">не активен</span>
          )}
        </div>
        <div className="my-3 list-group list-group-flush bg-white rounded border">
          {Object.keys(TARIFFS).map(x => (
            <div key={x} className="list-group-item py-3">
              <div className="row align-items-center">
                <div className="col">
                  <div className="fs-5">{TARIFFS[x].label}</div>
                  <div className="text-muted mt-2">{TARIFFS[x].price} тг.</div>
                </div>
                <div className="col-auto">
                  <button
                    onClick={() => activate({variables: {input: {tariff: x, noPercent: false}}})}
                    disabled={user.client.balance < TARIFFS[x].price}
                    className="btn btn-sm btn-primary"
                  >
                    подключить
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientPayments;
